import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message } from 'antd';
import adminApi from '../admin/config/adminApi';


const BusinessTypes = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [businessTypes, setBusinessTypes] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchBusinessTypes = async () => {
            setLoading(true);
            try {
                const response = await adminApi.get('/business-types');
                setBusinessTypes(response.data.business_types || []);
            } catch (error) {
                message.error("Failed to load business types.");
            } finally {
                setLoading(false);
            }
        };

        fetchBusinessTypes();
    }, []);

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            const response = await adminApi.post('/business-types', { name: values.name });
            setBusinessTypes([...businessTypes, response.data.business_type]);
            message.success("Business type added successfully");
            setIsModalVisible(false);
            form.resetFields();
        } catch (error) {
            if (error.response?.data?.errors?.name) {
                message.error(error.response.data.errors.name[0]);
            } else {
                message.error("Failed to add business type");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        selections: [
            Table.SELECTION_ALL,
            Table.SELECTION_INVERT,
            Table.SELECTION_NONE,
        ],
    };

    return (
        <div>
            <div style={{ textAlign: 'right', marginBottom: 16 }}>
                <Button type="primary" onClick={showModal}>
                    Add Business Type
                </Button>
            </div>

            <Table
                rowSelection={rowSelection}
                columns={[
                    { title: 'Business Type Name', dataIndex: 'name', key: 'name', width: 250 }
                ]}
                dataSource={businessTypes.map(item => ({ key: item.id, name: item.name }))}
                pagination={{ pageSize: 25 }}
                scroll={{ x: 'max-content' }}
                sticky
                loading={loading}
            />

            <Modal
                title="Add New Business Type"
                visible={isModalVisible}
                onOk={() => form.submit()}
                onCancel={handleCancel}
                confirmLoading={loading}
                okText="Add"
                cancelText="Cancel"
                destroyOnClose
            >
                <Form form={form} layout="vertical" onFinish={handleOk}>
                    <Form.Item
                        name="name"
                        label="Business Type Name"
                        rules={[{ required: true, message: 'Please enter the business type name!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default BusinessTypes;
